export default String.raw`
// smallCart
$(document).ready(function() {
    smallCart.init();
});


const smallCart = {
    init: function() {
        this.events();
	},

    openEditCartContainer: function(index) {
        document.getElementsByClassName('small-cart-name-js')[index].classList.add('hidden-js');
        document.getElementsByClassName('edit-small-cart-name-js')[index].classList.remove('hidden-js');
    },

    renameCart: async (index) => {
        const input = document.getElementsByClassName('small-cart-name-input-js')[index];
        const id = input.dataset.id;
        const name = input.value;
        await js.post({__action: 'Cart/NameSet', id: id, name: name});
        const elements = document.getElementsByClassName('small-cart-name-to-replace-js');
        for(const element of elements){
            element.innerHTML = name;
        }
        document.querySelector('.small-cart-change-popup-js [data-id="'+id+'"] .cart-name-in-change-cart-list-js').innerHTML = name;
        document.getElementsByClassName('small-cart-name-js')[index].classList.remove('hidden-js');
        document.getElementsByClassName('edit-small-cart-name-js')[index].classList.add('hidden-js');
    },
    events: function() {
        $('body').on('click', '.open-edit-small-cart-name-js', function(e) {
            if (e.target.classList && e.target.classList.contains('itemsList-js')) {
                smallCart.openEditCartContainer(1);
            } else {
                smallCart.openEditCartContainer(0);
            }
        });

        js.delegate(document.body, 'click', '.rename-small-cart-js', e => {
            if (e.target.classList && e.target.classList.contains('itemsList-js')) {
                smallCart.renameCart(1);
            } else {
                smallCart.renameCart(0);
            }
        });

        js.delegate(document.body, 'keydown', '.small-cart-name-input-js', e => {
            if (e.keyCode == 13) {
                if (e.target.classList && e.target.classList.contains('itemsList-js')) {
                    smallCart.renameCart(1);
                } else {
                    smallCart.renameCart(0);
                }
            }
        });

        $('body').on('click', '.toggle-small-cart-change-popup-js', function(e) {
            $(e.currentTarget).parent().find('.small-cart-change-popup-js').toggleClass('hidden-js');
        });

        $('body').on('click', '.small-cart-change-popup-js [data-id]', function(e){
            e.preventDefault();
            const isCurrent = $(this).data('current');
            if (!isCurrent) {
                const changeCartList = $(e.currentTarget).parents('.small-cart-change-popup-js');
                changeCartList.addClass('hidden-js');
                changeCartList.parent().find('.toggle-small-cart-change-popup-js .loader-js').removeClass('hidden-js');
        
                const id = $(this).data('id');
        
                $.post(null, { __csrf: __CSRF, __action: 'Cart/Change', id: id, __collection: 'customer.Cart.EditedOrderId' }, function (res) {
                    if (!res.collection) {
                        window.app.setCookie('lastCartId', id);
                    }
                    location.reload();
                });
            }
        });
    }
}
`